import { Component } from 'react';
import { Box, Grid } from '@mui/material';

export default class Paragraph extends Component {
    constructor(props) {
        super(props);
        let left = props.imageSide === 'left';
        let circle = props.imageType === 'circle';
        let image = props.image;
        let imageAlt = props.imageAlt;
        let text = props.children;

        this.state = {
            left,
            circle,
            image,
            imageAlt,
            text
        };
    }

    render() {
        const {
            left,
            circle,
            image,
            imageAlt,
            text
        } = this.state;

        let imageClassNames = left ? 'side-image side-image-left' : 'side-image side-image-right';
        imageClassNames = circle ? imageClassNames + ' side-image-circle' : imageClassNames + ' side-image-square';

        let gridText = <Grid key={1} className='center-flex' size={{ xs: 8, xl: 9 }} >
                            <Box>{text}</Box>
                        </Grid>;
        let gridImage = <Grid key={2} className='center-flex' size={{ xs: 4, xl: 3 }} >
                            <img className={imageClassNames} src={image} alt={imageAlt} />
                        </Grid>;
        if (left) {
            return (
                <Grid container sx={{ width: '100%' }} >
                    {gridImage}
                    {gridText}
                </Grid>
            );
        }

        return (
            <Grid container sx={{ width: '100%' }} >
                {gridText}
                {gridImage}
            </Grid>
        );
    }
}

